import type { ThemeItem } from "@/shared/types/theme";

export const THEME_OPTIONS = [
  {
    name: "默认",
    value: "default",
    color: "hsl(240 5.9% 10%)",
  },
  {
    name: "红色",
    value: "red",
    color: "hsl(0 72.2% 50.6%)",
  },
  {
    name: "玫瑰色",
    value: "rose",
    color: "hsl(346.8 77.2% 49.8%)",
  },
  {
    name: "绿色",
    value: "green",
    color: "hsl(142.1 76.2% 36.3%)",
  },
  {
    name: "紫色",
    value: "violet",
    color: "hsl(262.1 83.3% 57.8%)",
  },
  {
    name: "橙色",
    value: "orange",
    color: "hsl(24.6 95% 53.1%)",
  },
  {
    name: "黄色",
    value: "yellow",
    color: "hsl(47.9 95.8% 53.1%)",
  },
  {
    name: "蓝色",
    value: "blue",
    color: "hsl(221.2 83.2% 53.3%)",
  },
] as const satisfies readonly ThemeItem[];
